import { useState, useEffect } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import useAuth from "../context/User/useAuth";
import ModalAlert from "../components/ModalAlert";
import axios from "../utils/axios";

const Login = () => {
  const { setAuth } = useAuth();
  const [alerts, setAlert] = useState([]);
  const [formData, setFormData] = useState({
    email: "",
    password: "",
    persist: false,
    date: new Date().toISOString(),
  });

  useEffect(() => {
    const interceptor = axios.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.response?.status === 400) {
          return error.response;
        }
        return Promise.reject(error);
      }
    );
    return () => axios.interceptors.response.eject(interceptor);
  }, []);

  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from.pathname || "/";

  const { email, password, persist } = formData;

  const postEmployeeLogin = async (credentials) => {
    try {
      const { data } = await axios.post("employee/login", { data: credentials });
      return data;
    } catch (error) {
      if (!error.response) {
        throw error;
      }
      return error.response.data;
    }
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    loginFormValidate();
  };

  const loginFormValidate = async () => {
    const data = await postEmployeeLogin(formData);
    console.log(data);
    if (data.err === true && data.field === "email") {
      window.scroll(0, 0);
      setAlert([
        ...alerts,
        {
          id: (alerts.length + 1).toString(),
          type: "error",
          msg: "Invalid Email",
        },
      ]);
    } else if (data.err === true && data.field === "password") {
      window.scroll(0, 0);
      setAlert([
        ...alerts,
        {
          id: (alerts.length + 1).toString(),
          type: "error",
          msg: "Invalid Password",
        },
      ]);
    } else if (data.isAuthenticated) {

      setAuth({
        isAuthenticated: true,
        employee: {
          roles: data.employee.roles,
          firstName: data.employee.firstName,
          lastName: data.employee.lastName,
          _id: data.employee._id,
        },
      });
      navigate(from, { replace: true });
    }
  };

  const handleOnChange = (e) => {
    let updatedState = e.target.value;

    if (e.target.name === "persist") {
      persist === false ? (updatedState = true) : (updatedState = false);
    }
    setFormData((prevState) => ({
      ...prevState,
      [e.target.name]: updatedState,
    }));
  };
  return (
    <>
      <header>
        <div className="nav">
          <div className="card">
            <div className="logo">
              <Link to="/">Home</Link>
            </div>
            <ul></ul>
          </div>

          <button>
            <Link to="/login">Login</Link>
          </button>
        </div>
      </header>
      <section className="column">
        <ModalAlert alerts={alerts} setAlert={setAlert} />
        <h1 className="list">Login</h1>

        <form
          className="form-control onethird list column shadow"
          onSubmit={onSubmit}
        >
          <input
            className="form-input list"
            type="text"
            placeholder="email"
            name="email"
            value={email}
            onChange={(e) => {
              handleOnChange(e);
            }}
          />
          <input
            className="form-input list"
            type="password"
            placeholder="password"
            name="password"
            value={password}
            onChange={(e) => {
              handleOnChange(e);
            }}
          />
          {/* <div className="pair">
            <label>Stay Logged In</label>
            <input
              className="square"
              type="checkbox"
              name="persist"
              value={persist}
              onChange={(e) => {
                handleOnChange(e);
              }}
            />
          </div> */}
          <button className="btn-default" type="submit">
            Login
          </button>
        </form>
      </section>
    </>
  );
};
export default Login;
